var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"site",attrs:{"id":"site"}},[_c('site-menu'),_c('site-menu-icon'),_c('site-header'),_c('transition',{attrs:{"name":"site"}},[_c('router-view',{key:_vm.$route.fullPath})],1),_c('site-scroll'),_c('site-footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }